import { ModuleRouterState } from '../../types/module-router.types';

export class CompanyModuleRouterUtils {
  companyPath(companyId: ModuleRouterState['companyId'] | 'create'): string {
    if (!companyId) {
      throw new Error('Can not create company url without "companyId" argument!');
    }

    return `/company/${companyId}`;
  }

  modulePath(companyId: ModuleRouterState['companyId'], module: ModuleRouterState['module']): string {
    const companyPath = this.companyPath(companyId);

    if (!module) {
      throw new Error('Can not create module url without "module" argument!');
    }

    return `${companyPath}/${module}`;
  }

  submodulePath(
    companyId: ModuleRouterState['companyId'],
    module: ModuleRouterState['module'],
    submodule: ModuleRouterState['submodule']
  ): string {
    const modulePath = this.modulePath(companyId, module);
    if (!submodule) {
      throw new Error('Can not create submodule url without "submodule" argument!');
    }
    return `${modulePath}/${submodule}`;
  }

  detailPath(
    companyId: ModuleRouterState['companyId'],
    module: ModuleRouterState['module'],
    submodule: ModuleRouterState['submodule'],
    detailId: ModuleRouterState['detailId']
  ): string {
    const submodulePath = this.submodulePath(companyId, module, submodule);

    if (!detailId) {
      throw new Error('Can not create detail url without "detailId" argument!');
    }

    return `${submodulePath}/${detailId}`;
  }
}
